import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/home/runner/work/travis-med-ai.github.io/travis-med-ai.github.io/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "how-to-contribute"
    }}>{`How To Contribute`}</h1>
    <p>{`We want contributing to Travis Med AI to be simple and enjoyable.
All contributions are welcome, including issues, new docs as well as updates and tweaks, blog posts, workshops, and more.`}</p>
    <p>{`See our `}<a parentName="p" {...{
        "href": "/contributing/contributing-models"
      }}>{`contributing models`}</a>{` section for more information on how to contribute new models.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      